









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Dialog } from 'element-ui';
@Component({
  name: 'lb-dialog'
  // components: {
  //   'el-dialog': Dialog
  // }
})
export default class extends Vue {
  @Prop() private type!: string;
  @Prop({type: Boolean, default: false}) private visible!: boolean;
  @Prop({default: ''}) private title!: string;
  @Prop({type: Boolean, default: true}) private modal!: boolean;
  @Prop({type: Boolean, default: true}) private modalAppendToBody!: boolean;
  @Prop({type: Boolean, default: false}) private appendToBody!: boolean;
  @Prop({type: Boolean, default: true}) private lockScroll!: boolean;
  @Prop({type: Boolean, default: false}) private closeOnClickModal!: boolean;
  @Prop({type: Boolean, default: false}) private closeOnPressEscape!: boolean;
  @Prop({type: Boolean, default: true}) private showClose!: boolean;
  @Prop({default: '40%'}) private width!: string;
  @Prop({type: Boolean, default: false}) private fullscreen!: boolean;
  @Prop({default: ''}) private customClass!: string;
  @Prop({default: '7vh'}) private top!: string;
  @Prop({type: Boolean, default: false}) private destroyOnClose!: boolean;
  @Prop() private beforeClose!: any;
  @Prop({type: Boolean, default: false}) private center!: boolean;
  @Prop({type: Boolean, default: false}) private fixable!: boolean;

  private localVisible:boolean = this.visible;

  private handleOpen() {
    this.$emit('open');
  }

  private handleClose() {
    this.localVisible = false;
    this.$emit('close');
  }

  private handleOpened() {
    this.$emit('opened');
  }

  private handleClosed() {
    this.$emit('closed');
  }

  @Watch('visible')
  private onVisibleChange(visible: boolean) {
    this.localVisible = visible;
  }

  @Watch('localVisible')
  private onLocalVisibleChange(visible: boolean) {
    this.$emit('update:visible', visible);
  }
}
